import { toRank } from './rank'

/**
 * Dashboard-Ergänzung ohne Gegenstück in aivy-pdf-reports. Talent- und
 * Anforderungsprofil entscheiden hier gleich, ob die Kultur im long mode
 * rendert und was der Assistent zu einem Wert erzählt.
 */

/* Payloads ohne mode sind legacy und damit short. */
export const isCultureLong = (section) => section?.mode === 'long'

/* Dieselbe Prüfung, an der CultureRankedList sonst null zurückgibt. Eine
   Stelle, die den Partner-Superset erbt, liefert ranked_dimensions mit den
   Legacy-Rängen 0 und 100. Die Länge wäre dann größer 0, gerendert würde aber
   nur eine Überschrift ohne Karte. */
export const hasRankedDimensions = (section) =>
  Array.isArray(section?.ranked_dimensions) &&
  section.ranked_dimensions.some((item) => toRank(item?.rank) !== null)

/* detail kommt aus DIMENSIONS_CULTURE und ist Markdown, das mit "## Titel"
   beginnt. Fehlt es, bekommt der kurze description-Satz denselben Kopf, damit
   die Nachricht im Assistenten sagt, um welchen Wert es geht. */
export const getDimensionExplanation = ({
  title,
  description,
  detail
} = {}) => {
  if (detail) return detail
  if (!description) return title ? `## ${title}` : ''
  return title ? `## ${title}\n\n${description}` : description
}
